"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SlideContainerActions;
(function (SlideContainerActions) {
    SlideContainerActions["Hidden"] = "Hidden";
    SlideContainerActions["Shown"] = "Shown";
})(SlideContainerActions || (SlideContainerActions = {}));
exports.default = SlideContainerActions;
